import { Paper, TablePagination } from "@material-ui/core";
import { FC, useEffect } from "react";
import { useStyles } from "./style";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { daFeedbackChangeFilters, getDaFeedbackData } from "actions/daFeedbackActions";
import { useDispatch } from "react-redux";
import React from "react";

interface PropsType {}

const DaFeedbackHead: FC<PropsType> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { userData } = useTypeSelectors((state) => state.auth);
  const { feedbackListCount, feedbackFilters } = useTypeSelectors((state) => state.daFeedbackTable);

  useEffect(() => {
    if (userData.id) {
      const params = {
        page: feedbackFilters.pageNumber + 1,
        page_size: feedbackFilters.rowsPerPage,
        user: userData.id,
      };
      dispatch(getDaFeedbackData(params));
    }
  }, [dispatch, userData.id, feedbackFilters.pageNumber, feedbackFilters.rowsPerPage]);

  const handleChangePage = (event: unknown, value: number) => {
    dispatch(daFeedbackChangeFilters({ pageNumber: value }));
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(daFeedbackChangeFilters({ pageNumber: 0, rowsPerPage: +event.target.value }));
  };

  return (
    <Paper className={classes.paper}>
      <TablePagination
        component="div"
        rowsPerPageOptions={[10, 25, 50, 100]}
        count={feedbackListCount}
        rowsPerPage={feedbackFilters.rowsPerPage}
        page={feedbackFilters?.pageNumber}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onPageChange={handleChangePage}
      />
    </Paper>
  );
};

export default DaFeedbackHead;
